import axios from 'axios';
import { message } from 'antd';

// 基础 API 地址
export const BASE_URL = 'https://wecom.wzxn.top';

// 创建 axios 实例
const service = axios.create({
    baseURL: BASE_URL,
    // baseURL: 'https://wecom.wzxn.top', // 基础 API 地址
    timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        const token = localStorage.getItem('user_token');
        if (token) {
            // 让每个请求携带 token
            // ['X-Token'] 是自定义头部 key，请根据实际情况修改
            // 这里假设 API 不需要 header 里的 token，或者是以 query param 形式，或者 Bearer token
            // 根据通常惯例，这里放一个 Authorization header
            // 如果接口不需要 header 鉴权，可以注释掉
            config.headers['Authorization'] = `Bearer ${token}`;

            // 也可以放在 params 里，视具体 API 要求而定
            // config.params = { ...config.params, token };
        }
        return config;
    },
    error => {
        // 对请求错误做些什么
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;

        // 根据接口定义，code === 0 为成功
        if (res.code !== 0) {
            // 可以在这里处理特定的错误代码，例如 token 过期等
            if (res.code === 1002) {
                message.error(res.message || 'token已过期或无效');
                // Token 过期逻辑
                localStorage.removeItem('user_token');
                // 使用 window.location.href 跳转，确保刷新状态
                window.location.href = '/login';
            }
            // 对于其他错误，直接返回响应对象，让业务代码自己处理
            return res;
        } else {
            return res;
        }
    },
    error => {
        console.log('err' + error); // for debug
        message.error(error.message);
        return Promise.reject(error);
    }
);

export default service;
